import { render, staticRenderFns } from "./ExternalServiceIframe.vue?vue&type=template&id=6454c014&"
import script from "./ExternalServiceIframe.vue?vue&type=script&lang=ts&"
export * from "./ExternalServiceIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports